import { GlobalController } from 'src/shared/global/GlobalController'
import InvoiceReport from './InvoiceReport.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'invoice-report',
    name:
      'invoiceReport',
    component: InvoiceReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
